export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-20">
      <div className="label-eyebrow">Legal</div>
      <h1 className="wordmark mt-4 text-5xl md:text-6xl uppercase">Privacy Policy.</h1>
      <p className="mt-8 text-foreground/80">We collect only what we need to run your BA30 account: your email, name, and progress logs. We never sell your data. Progress photos, when enabled, are stored privately and visible only to you.</p>
      <p className="mt-4 text-foreground/80">Contact troyson@lifebuyersagency.com.au for any data request.</p>
    </div>
  );
}
